import { Plus } from "lucide-react";
import { Button } from "../ui/button";
import { useNavigate } from "@tanstack/react-router";
import { userAtom } from "@/store/user";
import { useAtom } from "jotai";

export const EmptyState = () => {
  const navigate = useNavigate();
  const [user] = useAtom(userAtom);

  return (
    <div className="flex min-h-screen flex-col items-center bg-neutral-50">
      <div className="flex flex-col items-center px-5">
        <span className="pb-6 pt-10 font-medium text-neutral-600">natauang</span>
        <div className="flex flex-col items-center opacity-80">
          <img
            width={288}
            height={113}
            src="/assets/empty-state-expense-chart.svg"
            alt=""
            loading="eager"
            className="pointer-events-none w-[85%]"
          />
          <img
            width={321}
            height={180}
            src="/assets/empty-state-expense-list.svg"
            loading="eager"
            alt=""
            className="pointer-events-none mt-10 w-[95%]"
          />
          <img
            width={321}
            height={180}
            src="/assets/empty-state-expense-list.svg"
            loading="eager"
            alt=""
            className="pointer-events-none mt-10 w-[95%] opacity-80"
          />
        </div>
      </div>

      <section className="fixed bottom-0 z-10 flex h-[90vh] w-full max-w-md flex-col bg-gradient-to-t from-white from-30% to-transparent sm:from-50%">
        <div className="flex h-full w-full flex-1 flex-col items-center justify-end pb-24 sm:justify-center sm:pt-40">
          <h1 className="text-center text-xl font-bold text-green-950">Belum Punya Pengeluaran</h1>
          <p className="pt-1 text-center text-sm text-green-900">
            Daftar pengeluaranmu akan muncul disini. <br /> Silahkan mulai buat pengeluaran
          </p>

          <div
            className="mt-6 rounded-md"
            style={{
              boxShadow:
                "0px 2px 5px 0px rgba(20, 83, 45, 0.10), 0px 8px 8px 0px rgba(20, 83, 45, 0.09), 0px 19px 11px 0px rgba(20, 83, 45, 0.05), 0px 34px 14px 0px rgba(20, 83, 45, 0.01), 0px 53px 15px 0px rgba(20, 83, 45, 0.00)",
            }}
          >
            <Button
              aria-label="Buat Pengeluaran"
              className=" border-green-300 bg-green-200 font-semibold text-green-900 !ring-green-700 hover:bg-green-300"
              autoFocus
              onClick={() => {
                navigate({ to: "/pengeluaran", search: {} });
              }}
            >
              Buat Pengeluaran
              <Plus size={20} className="ml-2" />
            </Button>
          </div>

          {!user && (
            <button
              onClick={() => {
                window.posthog?.capture?.("login");

                window.location.href = "/auth/google";
              }}
              className="mt-12 rounded px-4 py-2 text-sm font-semibold text-neutral-600"
            >
              <span>Sudah punya akun? Login disini</span>
            </button>
          )}
        </div>
      </section>
    </div>
  );
};
